import { Camera } from 'lucide-react';

export default function Gallery() {
  const images = [
    {
      url: "https://customer-assets.emergentagent.com/job_salon-kandivali/artifacts/pmifp5ni_IMG-20260211-WA0014.jpg",
      alt: "Hair Coloring Transformation"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_salon-kandivali/artifacts/18ew6ns4_IMG-20260211-WA0015.jpg",
      alt: "Beautiful Hair Highlights"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_salon-kandivali/artifacts/8gkhdew5_IMG-20260211-WA0016.jpg",
      alt: "Smooth Hair Treatment Result"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_salon-kandivali/artifacts/7pv5midn_IMG-20260211-WA0018.jpg",
      alt: "Professional Hair Styling"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_salon-kandivali/artifacts/t6k547w2_IMG-20260211-WA0022.jpg",
      alt: "Hair Smoothing & Color Work"
    }
  ];

  return (
    <div className="min-h-screen bg-[#0A0A0A] pt-32 pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-4">
            <Camera className="text-[#D4AF37]" size={40} />
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-white">
            Our <span className="text-[#D4AF37]">Work</span>
          </h1>
          <p className="text-lg text-[#A3A3A3] max-w-2xl mx-auto">
            Real transformations from our talented team - showcasing our expertise in hair coloring, highlights, and smoothing treatments
          </p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 space-y-4">
          {images.map((image, index) => (
            <div
              key={index}
              data-testid={`gallery-image-${index + 1}`}
              className="break-inside-avoid group relative overflow-hidden cursor-pointer border-2 border-neutral-800 hover:border-[#D4AF37] transition-all duration-300"
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-auto transition-all duration-500 group-hover:scale-110 brightness-95 contrast-110"
                style={{
                  filter: 'sepia(10%) saturate(120%)'
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p className="text-sm uppercase tracking-widest text-[#D4AF37] font-semibold">{image.alt}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-[#A3A3A3] mb-6">
            Want to be featured in our gallery? Book your transformation today!
          </p>
          <button
            data-testid="gallery-book-btn"
            onClick={() => {
              const message = encodeURIComponent("Hi, I'd like to book an appointment at Magic Touch Salon.");
              window.open(`https://wa.me/919870214490?text=${message}`, '_blank');
            }}
            className="bg-[#D4AF37] text-black font-semibold px-12 py-4 uppercase tracking-widest text-sm hover:bg-[#E5C15D] transition-all duration-300 gold-glow"
          >
            Book Appointment
          </button>
        </div>
      </div>
    </div>
  );
}
